import React from "react";
import "./Blogs.css";
import Solar_Insights from "../home/solar-insights/Solar_Insights";
import Free_Consultation from "../home/free-consultation/Free_Consultation";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Blog } from "../../utils/apis/blog/Blog";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../utils/context";
import { IDS } from "../../utils/common";

const Blogs = () => {
  const navigate = useNavigate();
  const handleServiceClick = (id) => {
    navigate(`/blog/${id}`);
  };

  const blogData = [
    {
      id: 1,
      image: "/assets/images/home/solar_insights/event-blog4.jpg",
      author: "Event Planner Team",
      date: "10 Oct 2024",
      title: "How to Plan a Dream Wedding Without Stress",
      desc:
        "Discover expert tips to organize your perfect wedding with ease, from venue selection to décor and seamless execution...",
    },
    {
      id: 2,
      image: "/assets/images/home/solar_insights/event-blog3 (5).jpg",
      author: "Event Planner Team",
      date: "12 Oct 2024",
      title: "Top Birthday Party Themes That Wow Your Guests",
      desc:
        "Explore creative and trending birthday themes that make your celebration unforgettable for both kids and adults...",
    },
    {
      id: 3,
      image: "/assets/images/home/solar_insights/event-blog3 (3).jpg",
      author: "Event Planner Team",
      date: "15 Oct 2024",
      title: "Engagement Party Ideas to Kickstart Your Journey",
      desc:
        "Make your engagement special with unique décor, entertainment, and planning ideas that reflect your love story...",
    },
    {
      id: 4,
      image: "/assets/images/home/solar_insights/event-blog3 (3).jpg",
      author: "Event Planner Team",
      date: "18 Oct 2024",
      title: "Corporate Events That Leave a Lasting Impression",
      desc:
        "Learn how to plan professional corporate events that enhance your brand image and engage your audience effectively...",
    },
    {
      id: 5,
      image: "/assets/images/home/solar_insights/event-blog3 (5).jpg",
      author: "Event Planner Team",
      date: "20 Oct 2024",
      title: "Essential Checklist for Flawless Event Execution",
      desc:
        "Stay organized with this complete event planning checklist to ensure every detail is covered for a successful event...",
    },
  ];

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { IMG_URL } = useContext(Context);

  const [blog, setBlog] = useState([]);

  const getBlog = async () => {
    const res = await Blog();

    if (res?.success) {
      setBlog(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getBlog();
  }, []);

  return (
    <>
      <section className="Blogs Solar_Insights">
        <div className="container">
          <div className="Solar_Insights_header_holder">
            <h5 className="Solar_Insights_header">
              Event Highlights & Latest Updates
            </h5>
            <p className="Solar_Insights_subtitle">
              Exclusive insights, latest trends, and expert guidance to elevate
              your event journey.
            </p>
          </div>
          <div className="blog_grid">
            {blog.map((blog) => (
              <div
                key={blog.id}
                className={`blog_card ${
                  blog.id <= 2 ? "blog_card_large" : "blog_card_small"
                }`}
                style={{
                  backgroundImage: `url(${IDS?.IMG_URL}${blog?.image})`,
                }}
                onClick={() => handleServiceClick(blog.id)}
              >
                <div className="blog_overlay">
                  <div className="blog_meta">
                    <FontAwesomeIcon icon={faUser} style={{ color: "#fff" }} />
                    <span className="author_name">{blog.name}</span>
                    <span className="date">
                      -{" "}
                      {new Date(blog.createdAt).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}
                    </span>
                  </div>

                  <h3 className="blog_title">{blog.title}</h3>
                  <p className="blog_desc">
                    {htmlToReactParser.parse(blog.description)}
                  </p>

                  <a href="#" className="read_more">
                    Read more
                  </a>
                </div>
              </div>
            ))}
          </div>
          <Free_Consultation />

          <div className="blog_grid">
            {blog.map((blog) => (
              <div
                key={blog.id}
                className={`blog_card ${
                  blog.id <= 2 ? "blog_card_large" : "blog_card_small"
                }`}
                style={{
                  backgroundImage: `url(${IDS?.IMG_URL}${blog?.image})`,
                }}
                onClick={() => handleServiceClick(blog.id)}
              >
                <div className="blog_overlay">
                  <div className="blog_meta">
                    <FontAwesomeIcon icon={faUser} style={{ color: "#fff" }} />
                    <span className="author_name">{blog.name}</span>
                    <span className="date">
                      -{" "}
                      {new Date(blog.createdAt).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}
                    </span>
                  </div>

                  <h3 className="blog_title">{blog.title}</h3>
                  <p className="blog_desc">
                    {htmlToReactParser.parse(blog.description)}
                  </p>

                  <a href="#" className="read_more">
                    Read more
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Blogs;
